export const ADD_TO_BASKET = 'ADD_TO_BASKET';
export const REMOVE_FROM_BASKET = 'REMOVE_FROM_BASKET';
export const SET_USER = 'SET_USER';
export const DELETE_BASKET = 'DELETE_BASKET';